import Component from './AddMonitors.vue';

export default {
  install(Vue) {
    Vue.component('BkfAddMonitors', Component);
  },
};
